// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__uXgMl","submit":"SignUp_submit__ISBlN","logo":"SignUp_logo__1uFKQ"};